import React from 'react';
import '../App.css';
import { Card, SectionHeader, Footer } from 'design-system-idm';
import TwitterLogo from '../assests/logo-twitter.png';
import FBLogo from '../assests/logo-fb.png';
import InstaLogo from '../assests/logo-insta.png';
import ClarkPark from '../assests/clarkpark.png';
import Oval from '../assests/oval.png';
import Sch from '../assests/sch.png';
import Plant from '../assests/plant.png';

function Activities() {
  return (
    <div className="activities">
    <div className="wrap">
      <div className="pad-left width-80 mar-bot-3">
        <h1>Activities</h1>
          <p> There are so many great things to do through Philadelphia Parks & Recreation. Visit a historic house, enjoy our pop-up beer gardens and seasonal activities, play in a league, have fun at a rec center, swim, hike, bike, do art, and more.</p>
      </div>
      <SectionHeader
      title="Upcoming Events"
      BCKGDcolor="#8CD9DE"/>
      <Card
      title="Weekday Walking Group at Tacony Creek Park"
      subtitle="June 22, 2020 - 9:00 am to 10:00 am"
      sepcolor="#8CD9DE"
      size="card-full"
      layout="col-2"
      dateAddOn="card-date"
      iconAddOn="icon-none"
      dateBCKGDcolor="#15AF53"
      day="22"
      month="June">The FREE walking group with WeWalk PHL will meet Monday and Saturday mornings every week. Join us at two gateways of Tacony Creek park, exercise together and share communal space. RSVP nagiarry@ttfwatershed.org or 215-744-1853. Thankful for this amazing partnership with We Walk PHL, Get Healthy Philly, Philly Powered, Fairmount Park Conservancy, PHL Dept of Public Health, and Philadelphia Parks and Recreation</Card>
      <Card
      title="Weekday Walking Group at Tacony Creek Park"
      subtitle="June 22, 2020 - 9:00 am to 10:00 am"
      sepcolor="#8CD9DE"
      size="card-full"
      layout="col-2"
      dateAddOn="card-date"
      iconAddOn="icon-none"
      dateBCKGDcolor="#15AF53"
      day="29"
      month="June">The FREE walking group with WeWalk PHL will meet Monday and Saturday mornings every week. Join us at two gateways of Tacony Creek park, exercise together and share communal space. RSVP nagiarry@ttfwatershed.org or 215-744-1853. Thankful for this amazing partnership with We Walk PHL, Get Healthy Philly, Philly Powered, Fairmount Park Conservancy, PHL Dept of Public Health, and Philadelphia Parks and Recreation</Card>
      <Card
      title="Little Explorers: Caterpillars, Dragonflies, and Butterflies"
      subtitle="July 1, 2020 - 10:00 am to 11:30 am"
      sepcolor="#8CD9DE"
      size="card-full"
      layout="col-2"
      dateAddOn="card-date"
      iconAddOn="icon-none"
      dateBCKGDcolor="#15AF53"
      day="01"
      month="July">Search for cool bugs in the Garden and make your very own insect sculpture. Designed for toddlers and pre-schoolers, ages 2-4. One adult chaperone is required for every two children. Each session includes activities, performances, snacks, and walks through the garden, weather permitting.</Card>
    
    <SectionHeader
      title="Featured Events"
      BCKGDcolor="#8CD9DE"/>
     <div className="flex mar-bot-3">
        <Card
        title="Movies in the Park"
        sepcolor="#8CD9DE"
        img="card-img"
        src={ClarkPark}
        alt="placeholder"
        dateAddOn="date-none"
      iconAddOn="icon-none"

        >
        UCD, in partnership with Philadelphia Parks and Recreation and Friends of Clark Park, will once again present Movies in Clark Park, four Fridays of free outdoor movies The films will be screened beginning at sundown in the Clark Park bowl during fair weather.
        </Card>
        <Card
        title="Plant Swap"
        sepcolor="#8CD9DE"
        img="card-img"
        src={Plant}
        alt="Plant"
        dateAddOn="date-none"
      iconAddOn="icon-none"
        >
          Join us on the first Saturday of every month 12:00pm-2:00pm beginning October 5th for our Community Plant Swap event! Buy, sell, or trade your plants while getting to know your community. If you are going to sell plants we request a donation be made to our recreation center but is not necessary.
        </Card>
      </div>

      <div className="flex mar-bot-3">
        <Card
        title="The Oval"
        sepcolor="#8CD9DE"
        img="card-img"
        src={Oval}
        alt="Oval in Art Museum"
        dateAddOn="date-none"
      iconAddOn="icon-none"
        >
       For four weeks this summer the Oval+ presented by PNC returns to Eakins Oval and the Benjamin Franklin Parkway, bringing more fun for all ages than ever before. The Oval+ continues to expand with more installations and more programming in more places extending from Eakins Oval eastward along the Parkway.
        </Card>
        <Card
        title="Summer on the Schuylkill"
        sepcolor="#8CD9DE"
        img="card-img"
        src={Sch}
        alt="Clark Park"
        dateAddOn="date-none"
      iconAddOn="icon-none"
        >
          There are several FREE educational programs which provide an opportunity for community groups to learn about the Schuylkill River Watershed, watershed threats and protection, and other environmental education lessons such as birding, native plant and tree identification, and water quality testing.
        </Card>
      </div>


     </div>
     <Footer
      BCKGDcolorLinks="#15AF53"
      BCKGDcolorContact="#03944f"
      links={[{
          href: "#",
          text: "Documents and forms"
        },{
          href: "#",
          text: "Press Releases"
        },{
          href: "#",
          text: "Rules and regulations"
        },{
          href: "#",
          text: "Fairmount Park Conservancy"
        },{
          href: "#",
          text: "Philadelphia Parks Alliance"
        },
      ]}
      address="1515 Arch Street, Philadelphia, PA 19102"
      email="parksandrecreation@phila.gov"
      phone="(215) 683-3600"
      logoTwitter={TwitterLogo}
      logoFB={FBLogo}
      logoInsta={InstaLogo}
      />
    </div>
  );
}

export default Activities;
